const CitiesSelectors = {
  cities: (state) => state.citiesReducer.cities,
  loading: (state) => state.citiesReducer.loading,
};

export default CitiesSelectors;
